import React from 'react';
import WarnIcon from '../../../common/icons/warn.svg';
import './style.scss';

class PreloaderPopup extends React.Component {
    render() {
        const { config } = this.props;

        return (
            <div className="preloader-popup">
                <div className="opl-widget-preloader--container">
                    {config.message && (
                        <div className="opl-widget-preloader--header">
                            <p>{config.message}</p>
                        </div>
                    )}
                    <div className="opl-widget-preloader--content">
                        <div className={`icon-container icon-container-${config.icon}`}>
                            {config.icon === 'spinner' && (
                                <div className="spinner spinner--orange" />
                            )}
                            {config.icon === 'exclamation' && <WarnIcon />}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PreloaderPopup;
